import React from "react";
import "./BottomTabBar.scss";

const isImagePath = (v) => typeof v === "string" && (v.startsWith("/") || v.startsWith("http") || v.startsWith("data:"));

const BottomTabBar = ({ tabs, activeTab, onTabClick }) => {
  return (
    <div className="bottom-tab-bar">
      <div className="bottom-tab-bar__wrapper">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`bottom-tab-bar__tab${activeTab === tab.id ? " active" : ""}`}
            onClick={() => onTabClick?.(tab.id)}
          >
            {tab.icon != null && (
              isImagePath(tab.icon) ? (
                <img src={tab.icon} alt="" className="bottom-tab-bar__icon" aria-hidden="true" />
              ) : (
                <span className="bottom-tab-bar__icon-text" aria-hidden="true">{tab.icon}</span>
              )
            )}
            {tab.label}
          </button>
        ))}
      </div>
      <div className="bottom-tab-bar__wrapper-pr">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`bottom-tab-bar__tab${activeTab === tab.id ? " active" : ""}`}
            onClick={() => onTabClick?.(tab.id)}
          >
            {tab.icon != null && (
              isImagePath(tab.icon) ? (
                <img src={tab.icon} alt="" className="bottom-tab-bar__icon" aria-hidden="true" />
              ) : (
                <span className="bottom-tab-bar__icon-text" aria-hidden="true">{tab.icon}</span>
              )
            )}
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomTabBar;
